/* eslint-disable */

export const CommerceOfferingKind = {
  Class: 'class',
  Event: 'event',
  Program: 'program',
  Appointment: 'appointment',
  Product: 'product',
  Gift: 'gift'
} as const;
export type CommerceOfferingKind = typeof CommerceOfferingKind[keyof typeof CommerceOfferingKind];
